export const PREBID_AD_WHITELIST = ['mrect', 'leaderc', 'spot', 'mmrect', 'mab', 'mspot'];

const PUBMATIC_CONFIG = {
  publisherId: '161958',
};
const cadentTagId = '181186';

const DEFAULT_PUBMATIC_AD_SLOT = '804007bc349e7c9e17432a3669945777';
const OPENX_DEL_DOMAIN = 'edmundsinc-d.openx.net';

const PREBID_INVENTORY_CONFIG = {
  'mobile.new.mdl': {
    pubmaticAdSlot: DEFAULT_PUBMATIC_AD_SLOT,
  },
  'wired.new.mdl': {
    pubmaticAdSlot: DEFAULT_PUBMATIC_AD_SLOT,
  },
  'mobile.carinventory': {
    pubmaticAdSlot: '8bf6e84d80a4e2985dcacf0a47be3f07',
  },
  'mobile.new.type': {
    pubmaticAdSlot: '13d99603c92b6ad9d8f7ca17b3ecae7c',
  },
  'mobile.used.mdl': {
    pubmaticAdSlot: 'c51b8ed37e5063d8c180851afcd1f40e',
  },
  'wired.carinventory': {
    pubmaticAdSlot: '16cbc95a5db05f16890bd98f363450bd',
  },
  'wired.new.type': {
    pubmaticAdSlot: 'bde70bb6d2ff513409c634129601339c',
  },
  'wired.used.mdl': {
    pubmaticAdSlot: 'af7dd3bfabefa817c5f73fb77c5f10b3',
  },
};

export const isPrebidEligibleAd = adName =>
  Boolean(adName && (PREBID_AD_WHITELIST.includes(adName) || adName.includes('mrect')));

const getInventoryName = adUnitPath => {
  if (typeof adUnitPath !== 'string') {
    return '';
  }

  const [, , inventoryName = ''] = adUnitPath.split('/');
  return inventoryName;
};

export function getBidderParamsForSlot(adUnitPath) {
  const inventoryName = getInventoryName(adUnitPath);
  if (!inventoryName) {
    return [];
  }

  const inventoryConfig = PREBID_INVENTORY_CONFIG[inventoryName];

  return [
    {
      bidder: 'pubmatic',
      params: {
        ...PUBMATIC_CONFIG,
        adSlot: inventoryConfig?.pubmaticAdSlot || DEFAULT_PUBMATIC_AD_SLOT,
      },
    },
    // Cadent Aperture MX bidder (requires custom Prebid bundle that includes the adapter).
    // Cadent uses the shared tag independently of PubMatic inventory overrides.
    {
      bidder: 'cadent_aperture_mx',
      params: { tagid: cadentTagId },
    },
    {
      bidder: 'openx',
      params: { delDomain: OPENX_DEL_DOMAIN },
    },
  ];
}

export function getPrebidAdUnit({ adName, slotId, adUnitPath, sizes }) {
  const bannerSizes = Array.isArray(sizes) ? sizes.filter(size => Array.isArray(size) && size[0] > 2) : [];
  const bids = getBidderParamsForSlot(adUnitPath);

  if (!isPrebidEligibleAd(adName) || !slotId || !bannerSizes.length || !bids.length) {
    return null;
  }

  return {
    code: slotId,
    mediaTypes: {
      banner: {
        sizes: bannerSizes,
      },
    },
    bids,
  };
}
